import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../../base/constant";
import { setSalesforceToken } from "../../../base/reducer/salesforceAuthSlice";

export const salesAuthenticationApi = createApi({
    reducerPath: "salesAuthentication",

    baseQuery: fetchBaseQuery({
        baseUrl: config().BASE_URL,
    }),

    endpoints: (builder) => ({
        postSfGetAuthToken: builder.mutation<any, string>({
            query: (portalToken) => ({
                url: "/auth/salesforce",
                method: "GET",
                headers: {
                    Authorization: `Bearer ${portalToken}`,
                },
            }),

            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    if (data?.result?.status) {
                        const tokenData = data.result.data;

                        const sfToken = `${tokenData.token_type} ${tokenData.access_token}`;

                        dispatch(setSalesforceToken(sfToken));
                    }
                } catch (error) {
                    console.error("Salesforce token error", error);
                }
            },
        }),
    }),
});

export const { usePostSfGetAuthTokenMutation } = salesAuthenticationApi;
